<template>
    <div class="chapter backgroundImage">
        <template v-if="list.length > 0">
            <div class="chapterList"
                :style="{ 'background': item.paperType == 'JSJ' ? '#CFCCE1' : item.paperType == 'DY' ? 'rgb(253 218 186)' : item.paperType == 'YY' ? '#FEAEA3' : item.paperType == 'SX' ? '#FDC594' : '#DBCFE7' }"
                v-for="item, index in list" :key="index" @click="openDeatilFn(item)">
                <p style=" font-weight: bold;"> {{ item.paperName || item.paperId_dictText }} </p>
                <div class="rightBox">
                    <div class="timeBox" v-if="!_isMobile() && item.openMethod == 2">
                        <p>开始时间：{{ item.startTime }}</p>
                        <p>结束时间：{{ item.endTime }}</p>
                    </div>
                    <div v-else-if="item.openMethod == 2" class="timeBox2">
                        <p>开始：{{ item.startTime }}</p>
                        <p>结束：{{ item.endTime }}</p>
                    </div>
                    <div> <span><i class="iconfont" v-if="item.mySubmitTimes > 0" style="color: rgb(39 229 18);font-size: 36px;">&#xe607;</i><i v-else class="iconfont">&#xe626;</i></span></div>
                </div>
            </div>
        </template>
        <template v-else>
            <a-empty :description="descriptionStr" />
        </template>
    </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { mixinDevice } from "@/utils/mixin.js";
export default {
    name: 'chapter',
    mixins: [mixinDevice],
    components: {},
    data() {
        return {
            list: [],
            descriptionStr: ''
        }
    },
    created() {
        this.descriptionStr = this.$route.query.type == 'ZXKS' ? '暂无考试' : '暂无作业'
        this.init(this.$route.query.status)
    },
    mounted() { document.title = this.$route.query.name },
    methods: {
        init(status) {
            getAction(`/teaching/teachingPaper/minePaperList?pageSize=999&isSimulation=${status}`).then(res => {
                if (res.success) {
                    this.list = res.result
                }
            })

        },
        openDeatilFn(row) {
            if(row.openMethod == 0){
                this.$message.error('尚未开始!')
                return
            }
            if(row.openMethod == 2){
                let startTime = new Date(row.startTime).getTime()
                let endTime = new Date(row.endTime).getTime()
                let newTime = new Date().getTime()
                console.log(startTime, 'startTime', endTime, 'endTime', newTime)
                if (newTime < startTime) {
                    this.$message.error('尚未开始!')
                    return
                }
                if (newTime > endTime) {
                    this.$message.error('已结束!')
                    return
                }
                if(this.$route.query.type == 'ZXKS' && row.mySubmitTimes >= row.submitTimesLimit){
                    this.$message.error('考试已达上限!')
                    return
                }
            }
            
            let url = this.$route.query.type == 'ZXKS' ? '/course/examEntrance' : '/examination/Workbook'
            const query = {
                paperDeptId: row.paperDeptId,
                paperId: row.paperId,
                departId: row.departId,
                timeLimit: row.timeLimit,
                submitTimesLimit: row.submitTimesLimit,
                paperName:row.paperName || row.paperId_dictText
            }
            if(this.$route.query.type != 'ZXKS'){
                delete query.timeLimit
                delete query.submitTimesLimit
                
            }
            this.$router.push({ path: url, query: query });
        }
    }
}
</script>

<style lang='scss' scoped>
.chapter {
    width: 100%;
    padding: 20px 17px;
    min-height: calc(100vh - 50px);
    background-image: url('../../assets/image/ZJ_background.png');
    max-width: 1200px;
    margin: 0 auto;

    .chapterList {
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(244, 244, 244, 0.863);
        border: 0px solid;
        border-image: linear-gradient(0deg, #000000, #FFFFFF) 10 10;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        color: #fff;
        font-size: 18px;
        border-radius: 5px;
        margin: 16px 0;
        padding: 0 16px;
        cursor: pointer;

        .rightBox {
            display: flex;
            align-items: center;
            justify-content: center;

            .timeBox {
                display: flex;
                margin-right: 8px;
                font-size: 16px;
                color: #666;
                line-height: 20px;

                p {
                    margin-right: 20px;
                }
            }

            .timeBox2 {
                font-size: 12px;
                line-height: 20px;

                p {
                    margin-right: 8px;
                }
            }

            .iconfont {
                color: #fff;
                box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
                padding: 0;
                border-radius: 50%;
            }

        }
    }

    .chapterList:hover {
        background: #F75250 !important;
        color: #fff;
    }
}
</style>
